import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import ExpensesAdmin from './IndexAdminExpenses';
import ExpensesSubAdmin from './IndexSubAdminExpenses';
import ExpensesSeller from './IndexSellerExpenses';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';

export default function ProductIndex() {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <ExpensesAdmin />
			break;
		case '2': 
			component = <ExpensesSeller />
      break;
    case '3': 
			component = <ExpensesSubAdmin />
			break;
		  default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
